// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"jp-z","breadcrumbForward":"kp-z","breadcrumbBack":"lp-z","selected":"mp-z"};